import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { tryFetch } from 'Helpers/FetchAPI';
import { getTokenOrDefault } from 'Helpers/Storage';
import { useSnackbar } from 'notistack';

interface MediaUploaderProps {
  onUploadSuccess: (url: string) => void;
  reference_type: 'PRODUCT_REVIEW';
  orderId?: string;
  productId?: string;
  currentImageCount: number;
}

const MediaUploader: React.FC<MediaUploaderProps> = ({
  onUploadSuccess,
  reference_type,
  orderId,
  productId,
  currentImageCount,
}) => {

  const { enqueueSnackbar } = useSnackbar();
  const [isUploading, setIsUploading] = useState(false);

  const handleDrop = async (acceptedFiles: File[]) => {
     if (currentImageCount >= 5) {
      enqueueSnackbar('You can only upload up to 5 images.', { variant: 'warning' });
      return;
    }

    const file = acceptedFiles[0];

    if (!file?.type.startsWith('image/')) {
       enqueueSnackbar('Only image files are allowed.', { variant: 'warning' });
      return;
    }

    if (!orderId || !productId) {
      enqueueSnackbar('Missing orderId or productId for review upload.', { variant: 'error' });
      return;
    }

     try {
      setIsUploading(true);

      const formData = new FormData();
      formData.append('file', file);
      formData.append('reference_type', reference_type); 
      formData.append('order_id', orderId);
      formData.append('product_id', productId);

      const query = `?file=${file.name}`;
      const url = `/g/orders/${orderId}/product/${productId}/review/upload`;
      const token = getTokenOrDefault();

      const response = await tryFetch({
        url,
        method: 'POST',
        token,
        formData,
        query,
      });

      if (response.is_success && typeof response.data === 'string') {
        onUploadSuccess(response.data);
        enqueueSnackbar('Image uploaded successfully!', { variant: 'success' });
      } else {
        console.error('Upload failed response:', response);
        enqueueSnackbar('Upload failed. Please try again.', { variant: 'error' });
      }
    } catch (error) {
      console.error('Upload error:', error);
      enqueueSnackbar('An error occurred while uploading. Please try again.', { variant: 'error' });
    } finally {
    setIsUploading(false); 
  }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: handleDrop,
    accept: { 'image/*': [] },
    disabled: isUploading || currentImageCount >= 5,
  });

   return (
    <div className="upload-wrapper">
      {isUploading ? (
        <div className="upload-loader">
          <div className="loader-bar" />
          <span>Uploading...</span>
        </div>
          ) : currentImageCount >= 5 ? (
        <div className="dropzone disabled">
          <p>You can only upload upto 5 images</p>
        </div>
      ) : (
        <div {...getRootProps()} className="dropzone">
          <input {...getInputProps()} />
          <p>Drag & drop an image here, or click to select a file</p>
        </div>
      )}
    </div>
  );
};

export default MediaUploader;

//   return (
//     <div {...getRootProps()} className="dropzone">
//       <input {...getInputProps()} />
//       <p>Drag & drop an image here, or click to select a file</p>
//     </div>
//   );
// };

// interface MediaUploaderProps {
//   onUploadSuccess: (url: string) => void;
// }

// const MediaUploader: React.FC<MediaUploaderProps> = ({ onUploadSuccess }) => {
//   const handleDrop = async (acceptedFiles: File[]) => {
//     const file = acceptedFiles[0];
//     if (!file.type.startsWith("image/")) {
//       alert("Only image files are allowed.");
//       return;
//     }

//     try {
//       const formData = new FormData();
//       formData.append("file", file);


//       const response = await fetch(
//         `https://storage.bunnycdn.com/gottit-media/${file.name}`,
//         {
//           method: "PUT",
//           headers: {
//             "AccessKey": process.env.REACT_APP_CB!,
//             "Content-Type": file.type,
//           },
//           body: file,
//         }
//       );

//       if (response.ok) {
//         const fileUrl = `https://gottit-media.b-cdn.net/${file.name}`;
//         onUploadSuccess(fileUrl);
//       } else {
//         alert("Failed to upload the image. Please try again.");
//       }
//     } catch (error) {
//       console.error("Error uploading file:", error);
//       alert("Error uploading the image. Please try again.");
//     }
//   };

//   const { getRootProps, getInputProps } = useDropzone({
//     onDrop: handleDrop,
//     accept: { "image/*": [] },
//   });

//   return (
//     <div {...getRootProps()} className="dropzone">
//       <input {...getInputProps()} />
//       <p>Drag & drop an image here, or click to select a file</p>
//     </div>
//   );
// };

// export default MediaUploader;
